
/**
 * 生成随机的六位数字
 * @static
 * @alias module:Rand.randNums
 * @since 1.0.0
 * @returns {String} 六位数字
 * 
 * @example
 *  randNums();
 *  // => 123456
 */
const randNums = () => {
    const chars = '0123456789'
    const maxPos = chars.length
    let code = ''
    for (let i = 0; i < 6; i++) {
        code += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return code
}

export default randNums;